import React, { useEffect } from "react";
import { generateGuid } from "./kendo_common";

export const KendoMultiSelect = ({
  name,
  url,
  data,
  placeholder,
  dataTextField,
  dataValueField,
  value,
  required,
  onValidate,
  onChange,
  autoBind = true,
  refreshWhen,
  tagmode,
}) => {
  const guid = generateGuid();

  useEffect(() => {
    if (!$(`#${guid}-${name}`).data("kendoMultiSelect")) {
      $(`#${guid}-${name}`).kendoMultiSelect({
        placeholder: placeholder,
        dataTextField: dataTextField,
        dataValueField: dataValueField,
        autoBind: autoBind,
        tagMode: tagmode,
        dataSource: url
          ? {
              serverFiltering: false,
              transport: {
                read: {
                  url: url,
                },
              },
            }
          : data || [],
        value: value,
        clearButton: true,
        change: function (e) {
          let selValue = this.value().join(",");
          $(`#hdn-${name}`).val(selValue);
          if (onChange) {
            onChange(selValue);
          }
          if (required && onValidate) {
            onValidate(name, $(`#hdn-${name}`).val());
          }
          if (required && !onValidate) {
            console.error(`function onValidate missing for field "${name}"`);
          }
        },
      });
    }
  }, []);

  

  useEffect(() => {
    if (data) {
      var multiSelect = $(`#${guid}-${name}`).data("kendoMultiSelect");
      multiSelect.setDataSource(data);
    }
  }, [data]);

  useEffect(() => {
    if (value != null && value != undefined) {
      var multiSelect = $(`#${guid}-${name}`).data("kendoMultiSelect");
      multiSelect.value(value);
      multiSelect.setOptions({ tagMode: value!=null&& value.length>1 ?"single":"multiple" });
      $(`#hdn-${name}`).val(value);
      // let a = $(".k-input-inner");
      // if (a != undefined) {
      //   a.style.display = "none";
      // }
    }
  }, [value, refreshWhen]);

  return (
    <>
      <input
        type="text"
        id={`hdn-${name}`}
        name={name}
        data-required={required || false}
        defaultValue={value || ""}
        style={{ display: "none"}}
      />
      <select id={`${guid}-${name}`} style={{height:"30px" }}></select>
    </>
  );
};
